// HIGH SPEED SHOP — Wishlist Interactions
import { showToast, storeUrl } from './hs_utils';

export function initWishlist() {
	// Load active wishlist state for heart buttons
	loadWishlistState();

	// Heart toggle on product cards and PDP
	document.addEventListener('click', function (e) {
		const btn = e.target.closest('.hs-btn-wishlist');
		if (!btn) return;
		e.preventDefault();
		e.stopPropagation();
		toggleWishlist(btn);
	});

	// Remove button on wishlist page
	document.addEventListener('click', function (e) {
		const btn = e.target.closest('.hs-wishlist-remove');
		if (!btn) return;
		e.preventDefault();
		removeFromWishlistPage(btn);
	});
}

export function loadWishlistState() {
	if (frappe.session.user === 'Guest') return;

	const buttons = document.querySelectorAll('.hs-btn-wishlist');
	if (!buttons.length) return;

	frappe.call({
		method: 'high_speed_shop.high_speed_shop.api.wishlist.get_wishlist_items',
		async: true,
		callback: function (r) {
			if (!r.message || !r.message.length) return;
			const codes = new Set(r.message);
			buttons.forEach(function (btn) {
				if (codes.has(btn.dataset.itemCode)) {
					btn.classList.add('active');
				}
			});
		},
	});
}

function toggleWishlist(btn) {
	if (frappe.session.user === 'Guest') {
		window.location.href = storeUrl('/login') + '?redirect-to=' + encodeURIComponent(window.location.pathname);
		return;
	}

	const itemCode = btn.dataset.itemCode;
	if (!itemCode) return;

	const isActive = btn.classList.contains('active');
	const method = isActive
		? 'high_speed_shop.high_speed_shop.api.wishlist.remove_from_wishlist'
		: 'high_speed_shop.high_speed_shop.api.wishlist.add_to_wishlist';

	frappe.call({
		method: method,
		args: { item_code: itemCode },
		callback: function () {
			btn.classList.toggle('active');
			showToast(isActive ? __('Removed from wishlist') : __('Added to wishlist'));
		},
	});
}

function removeFromWishlistPage(btn) {
	const itemCode = btn.dataset.itemCode;
	if (!itemCode) return;

	frappe.call({
		method: 'high_speed_shop.high_speed_shop.api.wishlist.remove_from_wishlist',
		args: { item_code: itemCode },
		callback: function () {
			const card = btn.closest('.hs-wishlist-item');
			if (card) card.remove();
			showToast(__('Removed from wishlist'));
			if (!document.querySelector('.hs-wishlist-item')) {
				window.location.reload();
			}
		},
	});
}
